import { render, staticRenderFns } from "./clientsList.vue?vue&type=template&id=4263aba1&scoped=true&"
import script from "./clientsList.vue?vue&type=script&lang=js&"
export * from "./clientsList.vue?vue&type=script&lang=js&"
import style0 from "./clientsList.vue?vue&type=style&index=0&id=4263aba1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4263aba1",
  null
  
)

export default component.exports